import { useMemo } from "react";

import { useUnauthenticatedSwrFetch } from "hooks/useUnauthenticatedSwrFetch";

interface UsePublicShipmentProps {
  token: string | undefined;
}

export function usePublicShipment(props: UsePublicShipmentProps) {
  const { token } = props;
  const url = useMemo(
    () => (token !== undefined ? `/public/shipments/${token}` : null),
    [token],
  );

  const { data, loading, error, mutate } =
    useUnauthenticatedSwrFetch<PublicShipment>({
      url,
      errorMessage: "Failed to fetch shipment",
    });

  return {
    shipment: data ?? null,
    loading,
    error,
    refetch: mutate,
  };
}
